export default __webpack_public_path__ + "static/media/infographie_etapes_4.ae7ade74.png";